'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (client) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : options,
      getKeysInterceptor = _ref.getKeysInterceptor;

  var getSigningKey = client.getSigningKey;

  return function (kid, cb) {
    getKeysInterceptor(function (err, keys) {
      if (err) {
        return cb(err);
      }

      var signingKeys = void 0;
      if (keys && keys.length) {
        signingKeys = (0, _utils.retrieveSigningKeys)(keys);
      }

      if (signingKeys && signingKeys.length) {
        var key = signingKeys.find(function (k) {
          return !kid || k.kid === kid;
        });

        if (key) {
          return cb(null, key);
        }
      }

      return getSigningKey(kid, cb);
    });
  };
};

var _utils = require('../utils');